module.exports = __webpack_public_path__ + "img/49_9.56c063db.png";